<template>
  <div v-if="isLoggedIn" class="flex items-center my-2 mr-5">
    <div class="ml-4" id="userPhoto">
      <UserAvatar :userEmail="AuthenticationHandler.account?.username ?? ''" :userName="AuthenticationHandler.account?.name ?? ''" size="medium" />
    </div>
    <div class="text-white text-sm ml-3 hidden lg:block">{{ AuthenticationHandler.account?.name ?? "" }}</div>
  </div>
  <div v-else class="flex items-center my-2 mr-5">
    <div class="text-white text-sm ml-5">Nicht angemeldet</div>
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted, onUnmounted, getCurrentInstance } from 'vue'
import AuthenticationHandler from "@/js/authentication"
import UserAvatar from "@/components/reusable/UserAvatar.vue"

// Access emitter
const instance = getCurrentInstance()
const emitter = instance?.appContext.config.globalProperties.$emitter

// Data
const isLoggedIn = ref(false)
const userPhotoSrc = ref('#')

// Computed
const storedUserPhoto = computed(() => localStorage.getItem('userImage'))

// Methods
const loadUserPhoto = () => {
  const userImage = localStorage.getItem('userImage')
  console.log('[UserInfo] Loading user photo from localStorage:', userImage ? 'Found (length: ' + userImage.length + ')' : 'Not found')
  if (userImage) {
    userPhotoSrc.value = userImage
    console.log('[UserInfo] User photo set to:', userPhotoSrc.value.substring(0, 50) + '...')
  } else {
    console.log('[UserInfo] No user photo in localStorage, will show fallback initials')
  }
}

// Lifecycle
onMounted(() => {
  AuthenticationHandler.setupMSALInstance()

  emitter?.on('login', (account) => {
    isLoggedIn.value = true
  })

  emitter?.on('logout', () => {
    isLoggedIn.value = false
  })

  AuthenticationHandler.setupLoginHandling(emitter)

  // Load user photo from localStorage on mount if already logged in
  if (AuthenticationHandler.account) {
    isLoggedIn.value = true
    loadUserPhoto()
  }
})

onUnmounted(() => {
  // Clean up event listeners
  emitter?.off('login')
  emitter?.off('logout')
})

// Watchers
watch(isLoggedIn, (newVal) => {
  if (newVal) {
    // Load user photo from localStorage with a delay to ensure it's been saved
    setTimeout(() => {
      loadUserPhoto()
    }, 500)
  }
})

watch(storedUserPhoto, (newVal) => {
  // Watch for changes to localStorage userImage
  if (newVal && isLoggedIn.value) {
    console.log('[UserInfo] localStorage userImage changed, reloading photo')
    loadUserPhoto()
  }
})
</script>